module.exports = __webpack_public_path__ + "img/软件产品-28.7244a6ad.jpg";